import { useState, useEffect } from 'react';

const useIndexDatabase = (dbName, version, storeName) => {
  const [db, setDb] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const request = indexedDB.open(dbName, version);
    request.onsuccess = (event) => { setDb(event.target.result); };
    request.onerror = (event) => { setError(event.target.error); };

    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains(storeName)) {
        db.createObjectStore(storeName, { keyPath: 'name' });
      }
    };
  }, [dbName, version]);

  const get = (key) => {
    return new Promise((resolve, reject) => {
      if (!db) return reject(new Error('Database not initialized'));

      const transaction = db.transaction(storeName, 'readwrite');
      const store = transaction.objectStore(storeName);
      const request = store.get(key);

      request.onsuccess = () => { resolve(request.result); };
      request.onerror = () => { reject(request.error); };
    });
  };

  const put = (value) => {
    return new Promise((resolve, reject) => {
      if (!db) return reject(new Error('Database not initialized'));

      const transaction = db.transaction(storeName, 'readwrite');
      const store = transaction.objectStore(storeName);
      const request = store.put(value);

      request.onsuccess = () => { resolve(request.result); };
      request.onerror = () => { reject(request.error); };
    });
  };

  const remove = (key) => {
    return new Promise((resolve, reject) => {
      if (!db) return reject(new Error('Database not initialized'));

      const transaction = db.transaction(storeName, 'readwrite');
      const store = transaction.objectStore(storeName);
      const request = store.delete(key);

      request.onsuccess = () => { resolve(request.result); };
      request.onerror = () => { reject(request.error); };
    });
  };

  return { db, error, get, put, remove };
};

export default useIndexDatabase;
